import {Quiz as QuizServer} from "../quiz/quiz-api";
import {Quiz} from "../../@types/Quiz";
import {SnapshotIn} from "mobx-state-tree";
import {QuizModelType} from "../quiz/QuizModel";


export const quizServerToQuizMSTSnapshotIn = (quizResponse: QuizServer | Quiz) => {
    const clientReadyValue: any = {...quizResponse};
    if (quizResponse.name === null) {
        clientReadyValue.name = '';
    }
    if (quizResponse.requiredPassPercentage === null) {
        clientReadyValue.requiredPassPercentage = 100;
    }
    if (quizResponse.questionsCount === null) {
        clientReadyValue.questionsCount = 0;
    }

    clientReadyValue.questionsOrder = (
        quizResponse.questionsOrder && typeof quizResponse.questionsOrder === 'string'
            ? JSON.parse(quizResponse.questionsOrder)
            : (typeof quizResponse.questionsOrder !== 'string' ? quizResponse.questionsOrder : [])
    );

    clientReadyValue.stats = (
        quizResponse.stats && typeof quizResponse.stats === 'string'
            ? JSON.parse(quizResponse.stats)
            : (typeof quizResponse.stats !== 'string' ? quizResponse.stats : {})
    );

    if (!quizResponse.meta) {
        clientReadyValue.meta = {};
    } else {
        clientReadyValue.meta = (
            typeof quizResponse.meta === 'string'
                ? JSON.parse(quizResponse.meta)
                : quizResponse.meta
        );
    }

    clientReadyValue.lastSavedObject = {...clientReadyValue};

    return clientReadyValue as SnapshotIn<QuizModelType>;
}
